import { useDeviceStatusLoading } from 'features/Integrations/hooks/useDeviceStatusLoading';
import { getDeviceStatusCode } from 'utils/devices/icon.utils';
import IntegrationStatusBadge from '../IntegrationStatusBadge/IntegrationStatusBadge';

const VALID_STATUSES = [
  'Online',
  'Open',
  'Idle',
  'Slow',
  'Rising',
  'Dropping',
  'Alerting',
  'Closed',
  'Flooding',
  'Warning',
  'Maintenance',
  'Loading',
  'Offline',
  'Major',
  'Moderate',
  'Minor',
  'Action',
  'Inactive',
  'Active',
  'API Error',
];

const getDisplayStatus = (device) => {
  const status = getDeviceStatusCode(device);
  const displayStatus = VALID_STATUSES.includes(status) ? status : 'Offline';

  if (!VALID_STATUSES.includes(status)) {
    console.error(`DeviceStatusBadge: Invalid status '${status}' for device`, device);
  }

  return device?.data || device?.device_type === 'Overwatch VMS' ? displayStatus : 'Offline';
};

export default function DeviceStatusBadge({ device }) {
  // No point yet and the covering fetch still in flight: not Offline, not known. The
  // badge itself renders the spinner and dots for the 'Loading' status.
  if (useDeviceStatusLoading(device)) {
    return <IntegrationStatusBadge status="Loading" />;
  }

  return <IntegrationStatusBadge status={getDisplayStatus(device)} />;
}
